import { Card, CardContent, CardHeader, CardTitle } from "@/shared/ui/card";
import { Zap } from "lucide-react";
import type { Asset } from "@/features/assets/hooks/usePropertyAssetRegistry";
import { buildSpecGroups } from "./specGroups";

export function SpecificationsCard({ asset }: { asset: Asset }) {
  const populated = buildSpecGroups(asset);
  if (populated.length === 0) return null;

  return (
    <Card className="animate-fade-in">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <Zap className="h-4 w-4 text-primary" />
          Specifications
        </CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4 items-start">
        {populated.map((group) => (
          <div key={group.title} className="space-y-2">
            <div className="text-[10px] uppercase tracking-wide text-muted-foreground font-semibold">
              {group.title}
            </div>
            <div className="grid grid-cols-1 gap-2">
              {group.fields.map((f) => (
                <div key={f.label} className="rounded-md border border-border/40 bg-muted/20 px-3 py-2">
                  <div className="text-[10px] uppercase tracking-wide text-muted-foreground">{f.label}</div>
                  <div className="text-sm font-semibold truncate">{f.value}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
